const RefundPolicyPage = () => {
  return (
    <div className="pt-32 pb-24" data-testid="refund-policy-page">
      <div className="chaleur-container">
        <div className="max-w-3xl mx-auto">
          <p className="caption text-primary mb-4">Legal</p>
          <h1 className="text-4xl md:text-5xl font-light mb-8">Refund & Return Policy</h1>
          <p className="text-muted-foreground mb-12">Last updated: February 2025</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-light mb-4">Our Commitment</h2>
              <p className="text-muted-foreground leading-relaxed">
                At Chaleur, we want you to be completely satisfied with your purchase. If for any reason you're not happy with your order, we're here to help.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Return Eligibility</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Items are eligible for return if they meet the following criteria:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Returned within 14 days of delivery</li>
                <li>Unused, unworn, and unwashed</li>
                <li>In original packaging with all tags attached</li>
                <li>Free from perfume, deodorant, or any other scents</li>
                <li>Not marked as "Final Sale" or purchased during clearance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Non-Returnable Items</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                The following items cannot be returned:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Customized or personalized items</li>
                <li>Items marked as "Final Sale"</li>
                <li>Gift cards</li>
                <li>Items that have been altered or damaged by the customer</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">How to Return</h2>
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-sm font-medium">1</div>
                  <div>
                    <h4 className="font-medium mb-1">Contact Us</h4>
                    <p className="text-muted-foreground text-sm">Email us at sabinakamal@gmail.com with your order number and reason for return.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-sm font-medium">2</div>
                  <div>
                    <h4 className="font-medium mb-1">Receive Return Authorization</h4>
                    <p className="text-muted-foreground text-sm">We'll send you a return authorization number and shipping instructions within 24-48 hours.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-sm font-medium">3</div>
                  <div>
                    <h4 className="font-medium mb-1">Ship Your Return</h4>
                    <p className="text-muted-foreground text-sm">Pack the item securely and ship it using a trackable method. For domestic orders, we provide a prepaid label.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-8 h-8 bg-primary text-primary-foreground flex items-center justify-center flex-shrink-0 text-sm font-medium">4</div>
                  <div>
                    <h4 className="font-medium mb-1">Receive Your Refund</h4>
                    <p className="text-muted-foreground text-sm">Once we receive and inspect your return, we'll process your refund within 5-7 business days.</p>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Refund Process</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Refunds will be issued to your original payment method:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li><strong>Credit/Debit Cards:</strong> 5-7 business days after processing</li>
                <li><strong>UPI/Net Banking:</strong> 3-5 business days after processing</li>
                <li><strong>International Cards:</strong> 7-14 business days depending on your bank</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-4">
                Original shipping charges are non-refundable unless the return is due to our error (wrong item shipped, defective product, etc.).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Exchanges</h2>
              <p className="text-muted-foreground leading-relaxed">
                We currently do not offer direct exchanges. If you'd like a different item, please return your original purchase for a refund and place a new order.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Damaged or Defective Items</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you receive a damaged or defective item, please contact us within 48 hours of delivery with photos of the damage. We'll arrange for a replacement or full refund including shipping costs.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-light mb-4">Questions?</h2>
              <p className="text-muted-foreground leading-relaxed">
                If you have any questions about our return and refund policy, please don't hesitate to contact us:
              </p>
              <div className="mt-4 p-6 bg-secondary/30 border border-border">
                <p className="font-medium">Sabina Kamal</p>
                <p className="text-muted-foreground">Email: sabinakamal@gmail.com</p>
                <p className="text-muted-foreground">Phone: +91 98107 50707</p>
                <p className="text-muted-foreground">WhatsApp: +91 98107 50707</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
